import _slicedToArray from "/codebuild/output/src3605572746/src/personal-website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.object.from-entries.js";

// src/anatomy.ts
function anatomy(name) {
  var map = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var called = false;

  function assert() {
    if (!called) {
      called = true;
      return;
    }

    throw new Error("[anatomy] .part(...) should only be called once. Did you mean to use .extend(...) ?");
  }

  function parts() {
    assert();

    for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
      values[_key] = arguments[_key];
    }

    for (var _i = 0, _values = values; _i < _values.length; _i++) {
      var part = _values[_i];
      ;
      map[part] = toPart(part);
    }

    return anatomy(name, map);
  }

  function extend() {
    for (var _len2 = arguments.length, parts2 = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      parts2[_key2] = arguments[_key2];
    }

    for (var _i2 = 0, _parts = parts2; _i2 < _parts.length; _i2++) {
      var part = _parts[_i2];
      if (part in map) continue;
      map[part] = toPart(part);
    }

    return anatomy(name, map);
  }

  function selectors() {
    var value = Object.fromEntries(Object.entries(map).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          part = _ref2[1];

      return [key, part.selector];
    }));
    return value;
  }

  function classnames() {
    var value = Object.fromEntries(Object.entries(map).map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          part = _ref4[1];

      return [key, part.className];
    }));
    return value;
  }

  function toPart(part) {
    var el = ["container", "root"].includes(part !== null && part !== void 0 ? part : "") ? [name] : [name, part];
    var attr = el.filter(Boolean).join("__");
    var className = "chakra-".concat(attr);
    var partObj = {
      className: className,
      selector: ".".concat(className),
      toString: function toString() {
        return part;
      }
    };
    return partObj;
  }

  var __type = {};
  return {
    parts: parts,
    toPart: toPart,
    extend: extend,
    selectors: selectors,
    classnames: classnames,

    get keys() {
      return Object.keys(map);
    },

    __type: __type
  };
} // src/components.ts


var accordionAnatomy = anatomy("accordion").parts("root", "container", "button", "panel").extend("icon");
var alertAnatomy = anatomy("alert").parts("title", "description", "container").extend("icon", "spinner");
var avatarAnatomy = anatomy("avatar").parts("label", "badge", "container").extend("excessLabel", "group");
var breadcrumbAnatomy = anatomy("breadcrumb").parts("link", "item", "container").extend("separator");
var buttonAnatomy = anatomy("button").parts();
var checkboxAnatomy = anatomy("checkbox").parts("control", "icon", "container").extend("label");
var circularProgressAnatomy = anatomy("progress").parts("track", "filledTrack").extend("label");
var drawerAnatomy = anatomy("drawer").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer");
var editableAnatomy = anatomy("editable").parts("preview", "input", "textarea");
var formAnatomy = anatomy("form").parts("container", "requiredIndicator", "helperText");
var formErrorAnatomy = anatomy("formError").parts("text", "icon");
var inputAnatomy = anatomy("input").parts("addon", "field", "element");
var listAnatomy = anatomy("list").parts("container", "item", "icon");
var menuAnatomy = anatomy("menu").parts("button", "list", "item").extend("groupTitle", "command", "divider");
var modalAnatomy = anatomy("modal").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer");
var numberInputAnatomy = anatomy("numberinput").parts("root", "field", "stepperGroup", "stepper");
var pinInputAnatomy = anatomy("pininput").parts("field");
var popoverAnatomy = anatomy("popover").parts("content", "header", "body", "footer").extend("popper", "arrow", "closeButton");
var progressAnatomy = anatomy("progress").parts("label", "filledTrack", "track");
var radioAnatomy = anatomy("radio").parts("container", "control", "label");
var selectAnatomy = anatomy("select").parts("field", "icon");
var sliderAnatomy = anatomy("slider").parts("container", "track", "thumb", "filledTrack");
var statAnatomy = anatomy("stat").parts("container", "label", "helpText", "number", "icon");
var switchAnatomy = anatomy("switch").parts("container", "track", "thumb");
var tableAnatomy = anatomy("table").parts("table", "thead", "tbody", "tr", "th", "td", "tfoot", "caption");
var tabsAnatomy = anatomy("tabs").parts("root", "tab", "tablist", "tabpanel", "tabpanels", "indicator");
var tagAnatomy = anatomy("tag").parts("container", "label", "closeButton");
export { accordionAnatomy, alertAnatomy, anatomy, avatarAnatomy, breadcrumbAnatomy, buttonAnatomy, checkboxAnatomy, circularProgressAnatomy, drawerAnatomy, editableAnatomy, formAnatomy, formErrorAnatomy, inputAnatomy, listAnatomy, menuAnatomy, modalAnatomy, numberInputAnatomy, pinInputAnatomy, popoverAnatomy, progressAnatomy, radioAnatomy, selectAnatomy, sliderAnatomy, statAnatomy, switchAnatomy, tableAnatomy, tabsAnatomy, tagAnatomy };